import { ROOT_API_URL } from 'constant/api';
import compose from 'lodash.flowright';
import PropType from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';

import createEnvironment from './environment';

const GqlClientContext = React.createContext(() => {});

export const withGqlClient = Component => props => (
  <GqlClientContext.Consumer>
    {({ environment }) => <Component environment={environment} {...props} />}
  </GqlClientContext.Consumer>
);

class GqlClient extends React.PureComponent {
  static propTypes = {
    history: PropType.object.isRequired,
    children: PropType.node.isRequired
  };

  constructor(props) {
    super(props);
    const { history } = props;
    this.environment = createEnvironment(ROOT_API_URL, history);
  }

  render() {
    return (
      <GqlClientContext.Provider value={{ environment: this.environment }}>
        {this.props.children}
      </GqlClientContext.Provider>
    );
  }
}

export default compose(withRouter)(GqlClient);
